import React, { useState } from "react";
import { Typography, Button, Grid, FormHelperText, FormControl, Paper } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import LoginContainer from "../LoginContainer";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useForm } from "react-hook-form";
import Warning from "../../../images/warning.svg";
import ModalConfirm from '../../../utils/form/modalConfirmBase';
import { updatePasswordUser } from '../../../actions/recoveryPassword-action';
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import { yupResolver } from "@hookform/resolvers/yup";
import { REQUIRED_MESSAGE,ERROR_MESSAGE } from "../../../constants";
import { parse, queryString } from 'query-string';
//import jwt from 'jwt-decode'
import * as yup from "yup";
import { styles }  from  '../styles';


const style = {
    paper: {
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        marginLeft: "25px"
    },
    form: {
        width: "100%",
    },
    password: {
    },
    submit: {
        background: '#666666',
        color: 'white',
        marginTop: "10px",
        width: "100%",
        marginBottom: 20,
        '&:hover': {
            color: 'white',
            background: '#099F9F'
        }
    },
    error: {
        "&.MuiFormHelperText-root.Mui-error": {
            color: "red"
        }
    },

};

const Recovery = (props) => {
    const classes = styles();
    //const [open, setOpen] = useState(false);
    const [disabledOnsubmit, setDisabledOnsubmit] = useState(false)
    const [usuario, setUsuario] = useState({
        username: "",
        password: "",
        showPassword: false
      });
    const [message, setMessage] = useState({
        description : '',
        textButtonSubmit : '',
        handleClick : () => {} ,
        oneButtons : false,
        type : '',
        open : false,
        image: '',
    })


    const schema = yup.object().shape({
        password: yup.string().required(REQUIRED_MESSAGE).max(15, 'Ingrese máximo 15 caracteres').matches(
            /^(?!.*[\s])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?\W)(?=.{8,15}$).*$/,
            `Debe contener mínimo 8 caracteres. Al menos una letra en minúscula.
            Al menos una letra en mayúscula. Al menos un número.
            Al menos un caracter especial (Ejemplo: !, $, #, % )`),
          validatePassword: yup.string().nullable().required(REQUIRED_MESSAGE).max(15, 'Ingrese máximo 15 caracteres').test('match',
          'Las contraseñas no coinciden',
           function(validatePassword) {
             return validatePassword === this.parent.password;
           }),
    });

      const { register, handleSubmit,  errors } = useForm({
        resolver: yupResolver(schema),

        mode: "onTouched",
        reValidateMode: "onChange",
      });



      const handleClick = () => props.history.push('/auth/login');
      const handleClickClose = () => {setMessage({...message, open: false}); setDisabledOnsubmit(false) }

      const changePassword = async (token, body) => {
        const response = await updatePasswordUser(body, token);
        if(response?.status > 200 && response?.status < 399){
            setMessage({
                description : 'Contraseña cambiada exitosamente',
                textButtonSubmit : 'Iniciar Sesión',
                handleClick : () => handleClick() ,
                oneButtons : true,
                type : 'SUCCESS',
                open : true
            })
        }else if(response?.status > 399 && response?.status === 401 || response?.status === 403){
            setMessage({
                description : response?.data?.detail ?? "La vigencia del link ha expirado, solicite uno nuevo",
                //description : "La vigencia del link ha expirado, solicite uno nuevo",
                textButtonSubmit : 'ACEPTAR',
                handleClick : () => handleClick() ,
                oneButtons : true,
                type : 'WARNING',
                open : true
            })
        }
        else {
            setMessage({
                type : 'WARNING',
                description : ERROR_MESSAGE,
                textButtonSubmit : 'ACEPTAR',
                handleClick : () => handleClickClose() ,
                oneButtons : true,
                open : true,
                image: Warning
            })
        }
    }

      const onSubmit = (data) => {
        setDisabledOnsubmit(true);
        const parsedQueryFalseDecode = parse(window.location.search, { decode: false });
        const parsedQueryTrueDecode = parse(window.location.search, { decode: true });
        const user = parsedQueryFalseDecode.username;
        const token = parsedQueryTrueDecode.token;
        const body = {
            password: data.password,
            username: user
        }
        changePassword(token, body);
      }


    const handleClickShowPassword = () => {
        setUsuario({ ...usuario, showPassword: !usuario.showPassword });
      };

      const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };

      const handleClickShowPasswordRevalidate = () => {
        setUsuario({ ...usuario, reValidatePassword: !usuario.reValidatePassword });
      };
     const handleMouseDownPasswordRevalidate = (event) => {
        event.preventDefault();
      };



    const recoveryComponent = () => (
        <React.Fragment>
            <ModalConfirm
            description = { message.description }
            textButtonSubmit = { message.textButtonSubmit }
            handleClick = { message.handleClick }
            oneButtons = { message.oneButtons }
            type = { message.type }
            open = { message.open }
            image = { message.image }
            />
        <Grid container spacing={0}>
                <Grid sm={12} md={12} lg = {12}>
                    <Paper style={style.paper} elevation={0}>
                        <Typography
                            className = { classes.stylesTypographyRestorePassword }
                        >
                            Restablecer Contraseña
                        </Typography>
                        <form style={style.form} onSubmit={ handleSubmit(onSubmit) }>
                        <Grid item xs={12} md={6} lg={12} style = {{ marginBottom: 20}}>
                            <FormControl className={classes.formControl} variant="outlined">
                                <InputLabel htmlFor="outlined-adornment-password"  error={errors.hasOwnProperty("password") && errors["password"].message}  >Contraseña</InputLabel>
                                <OutlinedInput
                                    inputRef={register}
                                    variant="outlined"
                                    type={usuario.showPassword ? 'text' : 'password'}
                                    label="Contraseña"
                                    defaultValue=''
                                    name="password"
                                    margin="normal"
                                    error={errors.hasOwnProperty("password") && errors["password"].message}
                                    endAdornment={
                                        <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {usuario.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    />
                                <FormHelperText style={{color: '#f44336'}}>{errors.hasOwnProperty("password") && errors["password"].message}</FormHelperText>
                            </FormControl>
                        </Grid>
                            <Grid item xs={12} md={6} lg={12}>
                            <FormControl   fullWidth variant="outlined" >
                                <InputLabel htmlFor="outlined-adornment-validatePassword" error={errors.hasOwnProperty("validatePassword") && errors["validatePassword"].message}>Repetir contraseña</InputLabel>
                                <OutlinedInput
                                    inputRef={register}
                                    variant="outlined"
                                    type={usuario.reValidatePassword ? 'text' : 'password'}
                                    label="Repetir contraseña"
                                    defaultValue=''
                                    margin="normal"
                                    name="validatePassword"
                                    error={errors.hasOwnProperty("validatePassword") && errors["validatePassword"].message}
                                    endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPasswordRevalidate}
                                            onMouseDown={handleMouseDownPasswordRevalidate}
                                            edge="end"
                                        >
                                        {usuario.reValidatePassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                    }/>
                                <FormHelperText style={{color: '#f44336'}}>{errors.hasOwnProperty("validatePassword") && errors["validatePassword"].message}</FormHelperText>
                            </FormControl>
                            </Grid>
                            <Grid container spacing={1} style={{justifyContent: 'center', margin: '8% 0px 20% 0px'}}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        className = { classes.submitRestorePassword }
                                        disableElevation
                                    >
                                        Cambiar contraseña
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Button
                                        variant="contained"
                                        disabled={disabledOnsubmit}
                                        className = { classes.buttonBackRestorePassword }
                                        onClick = { () => props.history.push('/auth/login')}
                                        disableElevation
                                    >
                                        Cancelar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    )

    return (
        <LoginContainer >
            {recoveryComponent()}
        </LoginContainer>
    );
};

export default withRouter(Recovery);
